import { Link, matchPath, useLocation } from "react-router";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from "@/components/ui/sidebar";

import { useVoltAreas, useVoltNavGroups } from "./useVoltNavGroups";
import type { VoltNavItem } from "./voltNavGroups";
import { useCloseMobile } from "./useCloseMobile";
import { VoltUserMenu } from "./VoltUserMenu";

export const VoltSidebar = () => {
  const areas = useVoltAreas();
  const groups = useVoltNavGroups(areas);
  const { pathname } = useLocation();
  const closeMobile = useCloseMobile();

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild size="lg" tooltip="Volt Hamburg Hub">
              <Link to="/" onClick={closeMobile}>
                <img
                  className="size-8 shrink-0 rounded"
                  src="/favicon.svg"
                  alt="Volt"
                />
                <span className="font-semibold leading-tight">
                  Volt Hamburg Hub
                </span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        {groups.map((group) => (
          <SidebarGroup key={group.key}>
            <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {group.items.map((item) => (
                  <NavItem
                    key={item.key}
                    item={item}
                    active={!!item.match && !!matchPath(item.match, pathname)}
                    onClick={closeMobile}
                  />
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
      <SidebarSeparator className="mx-0" />
      <SidebarFooter>
        <VoltUserMenu changelog={areas.changelog} />
      </SidebarFooter>
    </Sidebar>
  );
};

const NavItem = ({
  item,
  active,
  onClick,
}: {
  item: VoltNavItem;
  active: boolean;
  onClick: () => void;
}) => {
  const Icon = item.icon;
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild isActive={active} tooltip={item.label}>
        {item.href ? (
          <a
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
          >
            <Icon />
            <span>{item.label}</span>
          </a>
        ) : (
          <Link
            to={item.to ?? "/"}
            state={{ _scrollToTop: true }}
            onClick={onClick}
          >
            <Icon />
            <span>{item.label}</span>
          </Link>
        )}
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
